import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=4a008d73&"
import script from "./CustomMenu.vue?vue&type=script&lang=js&"
export * from "./CustomMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=4a008d73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports